<!--used to get the log of activities
component used in AuditTrail.vue
In (UI) organisations-> audit trail-> open any logId-> in modal there are logs as compared columns
-->
<template>
  <td width="40%" class="py-1">
    <tr v-if="value" class="col d-flex flex-column px-0 py-0" :class="{ changed: isChanged }">
      <td v-if="typeof value !== 'object'" class="wrap-text">{{ value }}</td>
      <td v-else v-for="val in value" :key="val.id">
        <node :node="val"></node>
      </td>
    </tr>
    <tr v-else>
      <td>NA</td>
    </tr>
  </td>
</template>
<script>
import node from '@//components/Common/RecursiveTree';
import { removeHTMLTags } from '@/helpers/common';
export default {
  components: { node },
  props: ['column', 'isChanged'],
  mounted() {
    this.getUserName();
  },
  data() {
    return {
      value: this.column
    };
  },
  watch: {
    value: function() {
      this.getUserName();
    }
  },
  methods: {
    // get the user name
    async getUserName() {
      if (typeof this.value === 'string') {
        this.value = removeHTMLTags(this.value);
      }
      if (
        typeof this.value === 'string' &&
        this.value.includes('_resolveEpoch')
      ) {
        const epoch = this.value.replace('_resolveEpoch', '');
        this.value = this.getFormatedDateAsPerTimeAndDate(parseInt(epoch, 10));
        return;
      }
      if (typeof this.value === 'string' && this.value.includes('_resolve')) {
        const userId = this.value.replace('_resolve', '');
        await this.addUserDetails([userId]);
        this.value = this.formatUserName(this.userIdNameMap[userId]);
      }
    }
  }
};
</script>
